import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", date => {
  if (date) {
    return moment(date).format("MMM DD");
  } else {
    return "n/a";
  }
});

Vue.filter("formatDateYear", date => {
  if (date) {
    return moment(date).format("MMM DD, YYYY");
  } else {
    return "n/a";
  }
});

Vue.filter("formatDateTime", date => {
  if (date) {
    return moment(date).format("MMM DD hh:mm a");
  } else {
    return "n/a";
  }
});

Vue.filter("formatNumber", val => {
  if (val) {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } else {
    return "0";
  }
});

Vue.filter("formatPhoneNumber", value => {
  if (value) {
    value = String(value);
    const phoneNumberRegex = /^1?(\d{3})(\d{3})(\d{4})$/;
    const match = phoneNumberRegex.exec(value);
    if (match) {
      const [, areaCode, prefix, lineNumber] = match;
      const formattedNumber = `(${areaCode}) ${prefix}-${lineNumber}`;
      return value.startsWith("1") ? `+1 ${formattedNumber}` : formattedNumber;
    } else {
      return value;
    }
  } else {
    return "";
  }
});
